/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Ad_Job_TitleInputs */

const en_confirm_ad_job_title = /** @type {(inputs: Confirm_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm AD Job Submission`)
};

const fr_confirm_ad_job_title = /** @type {(inputs: Confirm_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer la soumission de l'offre d'emploi`)
};

const de_confirm_ad_job_title = /** @type {(inputs: Confirm_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigung der AD-Stelleneinreichung`)
};

const it_confirm_ad_job_title = /** @type {(inputs: Confirm_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma l'invio della candidatura per l'annuncio di lavoro.`)
};

const ru_confirm_ad_job_title = /** @type {(inputs: Confirm_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердите отправку задания на размещение рекламы.`)
};

const es_confirm_ad_job_title = /** @type {(inputs: Confirm_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar el envío de la oferta de empleo de AD`)
};

const zh_cn2_confirm_ad_job_title = /** @type {(inputs: Confirm_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认广告职位提交`)
};

const ja_confirm_ad_job_title = /** @type {(inputs: Confirm_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD求人応募の確認`)
};

const hi_confirm_ad_job_title = /** @type {(inputs: Confirm_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विज्ञापन नौकरी सबमिशन की पुष्टि करें`)
};

const pt_pt2_confirm_ad_job_title = /** @type {(inputs: Confirm_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar envio de vaga de emprego para anúncio de emprego`)
};

/**
* | output |
* | --- |
* | "Confirm AD Job Submission" |
*
* @param {Confirm_Ad_Job_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const confirm_ad_job_title = /** @type {((inputs?: Confirm_Ad_Job_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Ad_Job_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_confirm_ad_job_title(inputs)
	if (locale === "de") return de_confirm_ad_job_title(inputs)
	if (locale === "it") return it_confirm_ad_job_title(inputs)
	if (locale === "ru") return ru_confirm_ad_job_title(inputs)
	if (locale === "es") return es_confirm_ad_job_title(inputs)
	if (locale === "zh-CN") return zh_cn2_confirm_ad_job_title(inputs)
	if (locale === "ja") return ja_confirm_ad_job_title(inputs)
	if (locale === "hi") return hi_confirm_ad_job_title(inputs)
	if (locale === "pt-PT") return pt_pt2_confirm_ad_job_title(inputs)
	return en_confirm_ad_job_title(inputs)
});